<h2 mat-dialog-title>{{ data.isNew ? 'Create' : 'Edit' }} Renderer</h2>
<mat-dialog-content>
  <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
    <mat-form-field appearance="outline">
      <mat-label>Renderer Name</mat-label>
      <input matInput formControlName="name" placeholder="Enter renderer name" [readonly]="!data.isNew">
      <mat-error *ngIf="form.get('name')?.hasError('required')">
        Name is required
      </mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Renderer Pool</mat-label>
        <mat-select formControlName="rendererPoolId">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let pool of rendererPools" [value]="pool.id">
            {{ pool.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button color="primary" matTooltip="Manage Pools" (click)="managePools()">
        <mat-icon>settings</mat-icon>
      </button>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Queue Check Interval (milliseconds)</mat-label>
      <input matInput type="number" formControlName="queueCheckIntervalInMilliseconds" 
        placeholder="Enter interval in milliseconds">
      <mat-hint>How often the renderer checks for new jobs</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="!data.isNew">
      <mat-label>Renderer Status</mat-label>
      <mat-select formControlName="rendererStatus">
        <mat-option *ngFor="let status of statusOptions" [value]="status.value">
          {{ status.label }}
        </mat-option>
      </mat-select>
      <mat-hint>Current status of the renderer</mat-hint>
    </mat-form-field>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="release-section">
      <mat-checkbox formControlName="canProcessRelease">Can Process Release Jobs</mat-checkbox>
      <mat-icon [color]="form.get('canProcessRelease')?.value ? 'primary' : ''" 
        [matTooltip]="form.get('canProcessRelease')?.value ? 'Release processing is enabled' : 'Release processing is disabled'">
        {{ form.get('canProcessRelease')?.value ? 'check_circle' : 'cancel' }}
      </mat-icon>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="loading">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()" 
    [disabled]="form.invalid || loading"
    [class.button-spinner]="loading">
    {{ data.isNew ? 'Create' : 'Update' }}
  </button>
</mat-dialog-actions>